(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waves-instagram-reels"] && !Shopify.designMode) return;
  try {
    
/* Waves "On the gram" reels. One silent clip plays at a time, with a pause and play button.
   Plain JS, no library. Each [data-waves-reels] section initialises once, and again after
   shopify:section:load in the theme editor. Arrow buttons and their scrolling stay in waves.js. */
(() => {
  "use strict";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const designMode = () => !!(window.Shopify && window.Shopify.designMode);

  function init(root) {
    if (!root || root.__wvReels) return;
    const rail = root.querySelector(".wv-reels__rail");
    const reels = Array.from(root.querySelectorAll("[data-reel]")).filter((r) => r.querySelector("video"));
    if (!rail || !reels.length) return;
    const st = { active: null, userPaused: false, inView: false };
    const vid = (r) => r.querySelector("video");
    const frame = (r) => r.querySelector("[data-reel-frame]");
    const btn = (r) => r.querySelector("[data-reel-toggle]");

    const allowAuto = () => !st.userPaused && !reduce.matches && !saveData && !designMode() && st.inView && !document.hidden;

    function setLabel(r, playing) {
      const b = btn(r);
      if (b) b.setAttribute("aria-label", playing ? b.dataset.labelPause : b.dataset.labelPlay);
    }
    function span(r) {
      const a = rail.getBoundingClientRect();
      const f = frame(r).getBoundingClientRect();
      return { full: f.left >= a.left - 1 && f.right <= a.right + 1, seen: Math.max(0, Math.min(a.right, f.right) - Math.max(a.left, f.left)) };
    }
    function firstVisible() {
      const full = reels.find((r) => span(r).full);
      if (full) return full;
      return reels.slice().sort((a, b) => span(b).seen - span(a).seen)[0];
    }
    function stop(r) {
      const v = vid(r);
      v.pause();
      if (r.classList.contains("is-started")) { try { v.currentTime = 0; } catch (e) { /* not seekable yet */ } }
      r.classList.remove("is-active", "is-playing", "is-started");
      setLabel(r, false);
    }
    function play(r) {
      const v = vid(r);
      v.muted = true;
      if (v.preload !== "auto") v.preload = "auto";
      const p = v.play();
      if (p && p.catch) p.catch(() => { /* autoplay refused (low power, policy): the poster stays and the button shows play */ });
    }
    function activate(r) {
      if (!r) return;
      reels.forEach((o) => { if (o !== r) stop(o); });
      st.active = r;
      r.classList.add("is-active");
      play(r);
    }
    function toggle(r) {
      if (st.active === r && !vid(r).paused) { st.userPaused = true; vid(r).pause(); return; }
      st.userPaused = false;
      activate(r);
    }
    function settle() {
      if (!allowAuto()) return;
      if (!st.active || !span(st.active).full) activate(firstVisible());
      else if (vid(st.active).paused) play(st.active);
    }

    reels.forEach((r) => {
      const v = vid(r);
      v.muted = true;
      v.addEventListener("playing", () => {
        if (st.active !== r) { v.pause(); return; }
        r.classList.add("is-playing", "is-started");
        setLabel(r, true);
      });
      v.addEventListener("pause", () => { r.classList.remove("is-playing"); setLabel(r, false); });
      const b = btn(r);
      if (b) b.addEventListener("click", (e) => { e.stopPropagation(); toggle(r); });
      frame(r).addEventListener("click", () => toggle(r));
    });

    let timer = 0;
    if ("onscrollend" in window) rail.addEventListener("scrollend", settle);
    else rail.addEventListener("scroll", () => { clearTimeout(timer); timer = setTimeout(settle, 150); }, { passive: true });

    if ("IntersectionObserver" in window) {
      const near = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        const v = vid(reels[0]);
        if (v.preload === "none") v.preload = "metadata";
        near.disconnect();
      }, { rootMargin: "200px 0px" });
      near.observe(rail);
      const io = new IntersectionObserver(([en]) => {
        const was = st.inView;
        st.inView = en.isIntersecting && en.intersectionRatio >= 0.35;
        if (st.inView && !was) {
          if (allowAuto()) activate(st.active && span(st.active).full ? st.active : firstVisible());
        } else if (!st.inView && was && st.active) {
          vid(st.active).pause();
        }
      }, { threshold: [0, 0.35, 0.5, 0.75, 1] });
      io.observe(rail);
    }

    document.addEventListener("visibilitychange", () => {
      if (!root.isConnected || !st.active) return;
      if (document.hidden) vid(st.active).pause();
      else if (allowAuto()) play(st.active);
    });
    const onReduce = () => { if (reduce.matches) { st.userPaused = true; if (st.active) vid(st.active).pause(); } };
    if (reduce.addEventListener) reduce.addEventListener("change", onReduce);
    else if (reduce.addListener) reduce.addListener(onReduce);

    root.__wvReels = {
      stopAll() { reels.forEach(stop); st.active = null; },
      show(li) {
        const a = rail.getBoundingClientRect();
        const pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        rail.scrollBy({ left: li.getBoundingClientRect().left - a.left - pad, behavior: "auto" });
      },
    };
  }

  const initAll = (scope) => (scope || document).querySelectorAll("[data-waves-reels]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();

  /* Theme editor: re-initialise a reloaded section, stop clips on unload, bring a selected reel to the start. */
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll("[data-waves-reels]").forEach((r) => { if (r.__wvReels) r.__wvReels.stopAll(); });
  });
  document.addEventListener("shopify:block:select", (e) => {
    const li = e.target.closest && e.target.closest("[data-reel]");
    const root = li && li.closest("[data-waves-reels]");
    if (root && root.__wvReels) root.__wvReels.show(li);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
